import { folder, id } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDocumentsRequestFailure(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isFailure : false;
    },
    isRetrieveDocumentsRequestPending(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isPending : false;
    },
    isRetrieveDocumentsRequestSuccess(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.request.isSuccessful : false;
    },
    getDocuments(namespace, type) {
      const result = getState().find(
        (req) => req.namespace === namespace && req.type === type,
      );

      return result ? result.folder : { ...folder, uuid: id };
    },
  };
}

export { createSelector };
